<template>
  <div class="loader">
    <div
      class="loader__circle-container"
      :style="`
        --width: ${width};
        --height: ${height};
      `"
    />
  </div>
</template>

<script>
export default {
  name: "AppLoaderComponent",
  props: {
    width: {
      type: String,
      required: true
    },
    height: {
      type: String,
      required: true,
    },
  }
}
</script>

<style lang="scss">
@import "~@/app/styles/blocks/loader";
</style>